import { render, staticRenderFns } from "./productDetailSpec.vue?vue&type=template&id=df95e6b8&scoped=true"
import script from "./productDetailSpec.vue?vue&type=script&lang=js"
export * from "./productDetailSpec.vue?vue&type=script&lang=js"
import style0 from "./productDetailSpec.vue?vue&type=style&index=0&id=df95e6b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df95e6b8",
  null
  
)

export default component.exports